// 19.1.3.1 Object.assign(target, source)
var $export = require('./_export');

$export($export.S + $export.F, 'Object', {assign: require('./_object-assign')});


// WEBPACK FOOTER //
// ./~/babel-runtime/~/core-js/library/modules/es6.object.assign.js